import { Logo } from '../components/Logo'
import { Usda } from '../components/Usda';
import {
  PageContainer,
  HeroSection,
  HeroContent,
  BackLink,
  ContentSection,
  Container,
  MainContent,
  SideContent,
  ProductTitle,
  ProductSubtitle,
  SectionTitle,
  SubSectionTitle,
  Paragraph,
  InfoTable,
  TableRow,
  TableDataLabel,
  TableData,
  List,
  AcoContainer,
  DecorativeElement
} from './ProductStyles';

export const CitrusParadisi16 = () => (
  <PageContainer>
    <HeroSection>
      <BackLink to="/">ホームに戻る</BackLink>
      <HeroContent>
        <Logo />
      </HeroContent>
    </HeroSection>

    <ContentSection>
      <Container>
        <MainContent>
          <DecorativeElement className="top-right" />
          <DecorativeElement className="bottom-left" />

          <ProductTitle>グレープフルーツ (ロット16)</ProductTitle>
          <ProductSubtitle>Citrus paradisi</ProductSubtitle>

          <SectionTitle>使用期限</SectionTitle>
          <Paragraph>{new Date('2027-06-30T00:00:00.000+09:00').toLocaleDateString()}</Paragraph>

          <SectionTitle>製品の特徴</SectionTitle>
          <InfoTable>
            <tbody>
              <TableRow>
                <TableDataLabel>原産国</TableDataLabel>
                <TableData>アメリカ</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>抽出部位</TableDataLabel>
                <TableData>果皮</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>抽出方法</TableDataLabel>
                <TableData>低温圧搾法</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>学名</TableDataLabel>
                <TableData>Citrus paradisi</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>科名</TableDataLabel>
                <TableData>ミカン科</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>効果</TableDataLabel>
                <TableData>リフレッシュ、香料、気分転換</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>INCI名</TableDataLabel>
                <TableData>Citrus Paradisi (Grapefruit) Peel Oil</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>CAS番号</TableDataLabel>
                <TableData>8016-20-4 ; 90045-43-5</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>品質</TableDataLabel>
                <TableData>100% Pure and Natural</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>ノート分類</TableDataLabel>
                <TableData>トップノート</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>ロット番号</TableDataLabel>
                <TableData>16</TableData>
              </TableRow>
            </tbody>
          </InfoTable>

          <SectionTitle>分析証明書</SectionTitle>

          <SubSectionTitle>製品識別と組成</SubSectionTitle>
          <List>
            <li>製品名: Grapefruit Essential Oil 100% Pure and Natural (ロット16)</li>
            <li>学名: Citrus paradisi</li>
            <li>バッチ番号: 10812505</li>
          </List>

          <SubSectionTitle>物理的および化学的特性</SubSectionTitle>
          <List>
            <li>外観: 淡黄色からオレンジ色の液体</li>
            <li>香り: フレッシュで軽やかなシトラス調、甘く、わずかにビターな香り</li>
            <li>屈折率: 1.472 @ 20°C</li>
            <li>比重: 0.854 @ 20°C</li>
            <li>旋光度: +90° 〜 +99°</li>
            <li>溶解性: アルコール類および固定油に可溶、水に不溶</li>
          </List>

          <SubSectionTitle>主要成分（EU アレルゲン申告）</SubSectionTitle>
          <List>
            <li>リモネン (Limonene): 96.0%</li>
            <li>ピネン (Pinene): 0.8%</li>
            <li>β-カリオフィレン (Beta-Caryophyllene): 0.4%</li>
            <li>シトラール (Citral): 0.1%</li>
            <li>ゲラニオール (Geraniol): 0.1%</li>
            <li>リナロール (Linalool): 0.1%</li>
          </List>

          <SubSectionTitle>品質検査</SubSectionTitle>
          <List>
            <li>微生物検査: 全項目適合（ISO 21149, ISO 16212, ISO 18416, ISO 21150, ISO 22717, ISO 22718）</li>
            <li>重金属検査: 全項目適合（鉛 &lt; 10ppm、ヒ素 &lt; 2ppm、水銀 &lt; 1ppm）</li>
            <li>IFRA適合: 第51次改正（2023年7月公布）準拠</li>
          </List>

          <SubSectionTitle>保管方法</SubSectionTitle>
          <Paragraph>密閉容器に入れ、直射日光を避けて冷暗所に保管してください。24ヶ月以上保管した場合は、使用前に品質を確認してください。</Paragraph>
        </MainContent>

        <SideContent>
          <AcoContainer>
            <Usda />
          </AcoContainer>
        </SideContent>
      </Container>
    </ContentSection>
  </PageContainer>
);
